module.exports = __webpack_public_path__ + "components/flag/static/square/sb-40b75bb26e43e2835071f7447b8f4259.svg";